import { CONSTANT } from "./Constant";
import { notification } from "antd";
import { debounce } from "lodash";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const dateFormatter = (
  date,
  format = CONSTANT.DATE_FORMATS.DMY_slash
) => {
  return dayjs(date).format(format);
};

export const dateTimeFormatter = (
  date,
  format = CONSTANT.DATE_FORMATS.DMYHMS_slash
) => {
  if (!date) return "";
  return dayjs.utc(date).local().format(format);
};

export const formatRtwPercent = (value) => `${Math.round(Number(value) || 0)}%`;

export const getLocalStorageData = (key) => {
  return JSON.parse(
    localStorage.getItem(key) ? localStorage.getItem(key) : null
  );
};

export const setLocalStorageData = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const generateUniqueNumber = () => {
  return Date.now() + Math.floor(Math.random() * 1000);
};

export const getSelectOptions = (
  list,
  isAdmin,
  forceIncludeAll = false,
  currentValue,
  allLabel = "All"
) => {
  if (!Array.isArray(list) || list.length === 0) return [];

  const baseList = list.filter((item) => item?.id && item.id !== "All");

  const withAll =
    isAdmin && forceIncludeAll
      ? [{ id: "All", name: allLabel }, ...baseList]
      : baseList;

  const valuesToEnsure = Array.isArray(currentValue)
    ? currentValue
    : [currentValue];
  const finalList = valuesToEnsure.reduce(
    (acc, val) => {
      if (val?.id && !withAll.some((item) => item.id === val.id)) {
        acc.push(val);
      }
      return acc;
    },
    [...withAll]
  );

  return finalList;
};

export const processIds = (input) => {
  const extractId = (item) => (typeof item === "object" ? item?.id : item);

  const values = Array.isArray(input) ? input : [input];
  const ids = values.map(extractId).filter((id) => id && id !== "All");
  const isAll = values.some((v) => extractId(v) === "All");

  return { isAll, ids };
};

export const ensureDropdownIncludesValue = (list, value) => {
  if (!value) return list;
  const exists = list.some((item) => item.id === value.id);
  return exists ? list : [...list, value];
};

export const validateFields = debounce((form, setDisabled) => {
  form
    .validateFields()
    .then(() => {
      setDisabled(false);
    })
    .catch(() => {
      setDisabled(true);
    });
}, 500);

export const dataToFormdataConverter = (data) => {
  const formData = new FormData();
  for (let name in data) {
    const value = data[name];

    if (value !== "" && value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        name = `${name}[]`;
        value.forEach((item_values) => {
          formData.append(name, item_values);
        });
      } else {
        formData.append(name, value);
      }
    }
    // formData.append(name, data[name]); // there should be values.avatar which is a File object
  }

  return formData;
};

export const Notification = {
  success: (data) => {
    notification.success({
      placement: data.placement ? data.placement : "topRight",
      duration: 5,
      key: Math.random().toString(),
      ...data,
    });
  },
  error: (data) => {
    notification.error({
      placement: data.placement ? data.placement : "topRight",
      duration: 5,
      key: Math.random().toString(),
      ...data,
    });
  },
};

export const appendFormData = (formData, data, parentKey = "") => {
  if (data instanceof Blob || data instanceof File) {
    // If it's a Blob or File, append it directly
    formData.append(parentKey, data);
  } else if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      appendFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    formData.append(parentKey, data);
  }
};

export const convertToFormData = (nestedObject) => {
  const formData = new FormData();
  appendFormData(formData, nestedObject);
  return formData;
};

export const capitalizeFirstCharacter = ([firstLetter, ...rest]) =>
  firstLetter.toUpperCase() + rest.join("");

export const base64ToBlobUrl = (base64String) => {
  try {
    // Remove any data URI prefix if present
    const base64Data = base64String.replace(
      /^data:application\/pdf;base64,/,
      ""
    );

    // Decode Base64 to binary
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    // Convert binary string to byte array
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Create Blob from byte array
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Create Blob URL
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  } catch (error) {
    console.error("Error converting Base64 to Blob URL:", error);
    return null;
  }
};
